function checkValue(fields) {
    let count = 0;
    let value = "";
    let valid = true;
    for (const field of fields) {
        field.classList.remove("error");
        field.setCustomValidity('');
        if (count === 0) {
            value = field.value;
        } else {
            if (value !== field.value) {
                valid = false;
                field.classList.add("error");
                if (GLOBALS.tc.hint_same_passwords) {
                    field.setCustomValidity(GLOBALS.tc.hint_same_passwords);
                }
            }
        }
        count++;
    }

    return valid;
}

function togglePasswordFields(wrapper) {
    wrapper.classList.toggle("is-active");
    for (const field of wrapper.querySelectorAll('input')) {
        if (wrapper.classList.contains("is-active")) {
            field.setAttribute("type", "text");
        } else {
            field.setAttribute("type", "password");
        }
    }
    for (const icon of wrapper.querySelectorAll('.passwordToggle .icon')) {
        icon.classList.toggle("icon-password-show");
        icon.classList.toggle("icon-password-hide");
    }
}

function generatePasswordToggle(field, wrapper) {
    const togglePassword = document.createElement("div");
    togglePassword.classList.add("passwordToggle");
    togglePassword.classList.add("inputGroup__addon");
    togglePassword.classList.add("inputGroup__addon--clickable");
    togglePassword.innerHTML = "<i class='icon icon-password-show'></i>";
    field.closest('.inputGroup').appendChild(togglePassword);
    field.closest('.inputGroup').classList.add('inputGroup--infieldAddon');
    field.closest('.inputGroup').classList.add('password');
    togglePassword.addEventListener("click", function () {
        togglePasswordFields(wrapper);
    });
}

export function initPasswordToggles() {
    for (let field of document.querySelectorAll('.js-passwordToggle')) {
        const wrapper = field.closest('.js-passwordFields');
        if (wrapper) {
            generatePasswordToggle(field, wrapper);
        }
    }
}

export function initPasswordCheckers() {
    for (let field of document.querySelectorAll('.js-passwordChecker')) {
        const wrapper = field.closest('.js-passwordFields');
        if (wrapper) {
            const requirementList = wrapper.querySelector('.js-passwordRequirements');
            if (requirementList) {
                initPasswordChecker(field, requirementList);
            }
        }
    }
}

export function initPasswordFields() {
    const useGeneratePasswordToggle = false;
    for (const wrapper of document.querySelectorAll('.js-passwordFields')) {
        const fields = wrapper.querySelectorAll('input[type="password"]');
        if (fields) {
            for (const field of fields) {
                if(useGeneratePasswordToggle){
                    generatePasswordToggle(field, wrapper);
                }
                field.addEventListener("change", function () {
                    checkValue(fields);
                });
            }
        }
    }

    initPasswordToggles();
    initPasswordCheckers();
}

export function initPasswordChecker(passwordField, requirementList) {

    // Dynamische Mindestlänge aus HTML
    const minLength = parseInt(requirementList.dataset.minlength, 10) || 12;

    // Regeln dynamisch erzeugt
    const requirements = {
        length: {
            label: `${GLOBALS.tc.atLeast || 'Mindestens'} ${minLength} ${GLOBALS.tc.characters || 'Zeichen'}`,
            regex: new RegExp(`.{${minLength},}`)
        },
        lower: {
            label: `1 ${GLOBALS.tc.lowercaseLetter || 'Kleinbuchstabe'}`,
            regex: /[a-z]/
        },
        upper: {
            label: `1 ${GLOBALS.tc.uppercaseLetter || 'Großbuchstabe'}`,
            regex: /[A-Z]/
        },
        number: {
            label: `1 ${GLOBALS.tc.digit || 'Ziffer'}`,
            regex: /\d/
        },
        special: {
            label: `1 ${GLOBALS.tc.specialCharacter || 'Sonderzeichen'}`,
            regex: /[^a-zA-Z0-9]/
        }
    };

    if (!passwordField || !requirementList) return;

    // Dynamisch LI erzeugen
    Object.keys(requirements).forEach(key => {
        const li = document.createElement("li");
        li.setAttribute("data-check", key);
        li.textContent = requirements[key].label;
        requirementList.appendChild(li);
        requirements[key].element = li;
    });


    function checkPassword() {
        const value = passwordField.value;

        // nur prüfen, wenn Wert nicht leer
        if (!value) {
            Object.keys(requirements).forEach(key => {
                const req = requirements[key];
                req.element.classList.remove("is-valid", "is-invalid");
            });
            return;
        }

        Object.keys(requirements).forEach(key => {
            const req = requirements[key];
            if (req.regex.test(value)) {
                req.element.classList.add("is-valid");
                req.element.classList.remove("is-invalid");
            } else {
                req.element.classList.remove("is-valid");
                req.element.classList.add("is-invalid");
            }
        });
    }

    passwordField.addEventListener("input", checkPassword);
}

